<template>
  <div>
    <p align="center">
      <span style="font-size: large;margin-bottom:30px">
        <span lang="en-US">
          <strong>ARAPORCEI S.L. (*) as a certification body approved by GLOBALG.A.P. awards this</strong>
        </span>
      </span>
    </p>

    <p align="center">
      <span style="color: #00b050;">
        <span style="font-size: 400%;margin-top:40px">
          <span lang="en-US">
            <strong>GLOBAL</strong>G.A.P. <strong>CERTIFICATE</strong>
          </span>
        </span>
      </span>
    </p>

    <p align="center">
      <sup>
        <span style="font-size: large;">
          <span lang="en-US">
            <strong>Issued to</strong>
          </span>
        </span>
      </sup>
    </p>

    <p style="text-align:center;margin-bottom:0;margin-top:30px">
      <sup>
        <span style="font-size: 400%;">
          <strong>{{clienteNombreCompleto}}</strong>
        </span>
      </sup>
    </p>

    <template v-if="isPienso">
      <p style="text-align:center;margin-top:0">
        <sup>
          <span style="font-size: 200%;">{{ this.datos.cliente.direccion }}</span>
        </sup>
      </p>

      <p style="margin-top:20px;margin-bottom:5px;text-align:center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              <strong>GGN: {{ this.datos.cliente.codigo }}</strong>
            </span>
          </span>
        </sup>
      </p>

      <p style="text-align:center;margin-top:5px;margin-bottom:5px">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              CB-SHORT Nº: {{ this.datos.codigo }}
            </span>
          </span>
        </sup>
      </p>

      <p style="text-align:center;margin-top:5px;margin-bottom:5px">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              According to
            </span>
          </span>
        </sup>
      </p>

      <p style="text-align:center;margin-top:5px;margin-bottom:5px">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              GLOBALG.A.P. GENERAL REGULATIONS. COMPOUND FEED MANUFACTORING V 5.2_Octubre 2020
            </span>
          </span>
        </sup>
      </p>

      <p style="text-align:center;margin-top:5px;margin-bottom:5px">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              OPTION 1
            </span>
          </span>
        </sup>
      </p>

      <p align="center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              COUNTRY OF PRODUCTION: SPAIN
            </span>
          </span>
        </sup>
      </p>

      <div style="font-size: large;border-top:1px solid #000;border-bottom:1px solid #000;width:88%;margin-left:auto;margin-right:auto;text-align:center">
        <p style="margin-top:0">
          <strong>
            ARAPORC ENTIDAD DE INSPECCION, S.L (*) declares that the production of the products mentioned<br />
            on this certificate has been found to be compliant in accordance with the standard:
          </strong>
        </p>
        <p style="margin-bottom:0">
          <strong>GLOBALG.A.P. Control Points and Compliance Criteria Compound Feed Manufacturing. Version 2.2_Mayo<br />2017</strong>
        </p>
      </div>

      <div style="margin-left:15%;margin-right:auto;width:80%;margin-top:40px">
        <table cellspacing="0" cellpadding="3">
          <tbody>
            <tr style="width:100%">
              <td style="background:#d9d9d9;width:20%">
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>PRODUCT<br />(Producto)</strong>
                  </span>
                </span>
                </p>
              </td>
              <td style="background:#d9d9d9;">
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>GLOBALG.A.P. PRODUCT<br />CERTIFICATE NUMBER<br />(N° de Certificado GG)</strong>
                  </span>
                </span>
                </p>
              </td>
              <td style="background:#d9d9d9;">
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>PARALLEL<br />OWNERSHIP<br />(Propiedad<br />paralela)</strong>
                  </span>
                </span>
                </p>
              </td>
              <td style="background:#d9d9d9;">
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>PARALLEL<br />PRODUCTION<br />(Producción<br />paralela)</strong>
                  </span>
                </span>
                </p>
              </td>
              <td style="background:#d9d9d9;">
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>INSPECTION<br />AUDIT<br />(Tipo de<br />auditoria)</strong>
                  </span>
                </span>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>COMPOUND FEED FOR<br />LIVESTOCK<br />(Fabricación de pienso<br />para animales)</strong>
                  </span>
                </span>
                </p>
              </td>
              <td>
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong></strong>
                  </span>
                </span>
                </p>
              </td>
              <td>
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>{{ this.datos.solicitud.params.globalgap.animales_certificados_pienso == 0 ? 'NO' : 'YES' }}</strong>
                  </span>
                </span>
                </p>
              </td>
              <td>
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong></strong>
                  </span>
                </span>
                </p>
              </td>
              <td>
                <p align="center">
                <span style="font-size: small;">
                  <span lang="en-US">
                    <strong>{{ this.datos.auditoria.tipo_visita.nombre }}</strong>
                  </span>
                </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    
    <template v-else-if="isGanaderia">

      <p style="text-align:center;margin-top:20px">
        <sup>
          <span style="font-size: large;">{{ this.datos.cliente.direccion }}</span>
        </sup>
      </p>

      <p style="text-align:center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-US">{{ this.datos.cliente.cp }} {{ this.datos.cliente.municipio.nombre }} &ndash; {{ this.datos.cliente.provincia.nombre }} - {{ this.datos.cliente.pais.nombre }}.</span>
          </span>
        </sup>
      </p>

      <p style="text-align:center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              <strong>GGN: {{ this.datos.cliente.codigo }}</strong>
            </span>
          </span>
        </sup>
      </p>

      <p style="text-align:center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">
              <strong>COUNTRY OF PRODUCTION: SPAIN</strong>
            </span>
          </span>
        </sup>
      </p>
    
      <p style="text-align:center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">REGISTRATION N&ordm;: {{this.datos.codigo}}</span>
          </span>
        </sup>
      </p>

      <p style="text-align:center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-GB">TYPE OF AUDIT: <span v-for="tipo in this.datos.solicitud.sites" :key="tipo.nombre">{{tipo.nombre}}</span></span>
          </span>
        </sup>
      </p>
      
      <p style="text-align:center">
        <sup>
          <span style="font-size: large;">
            <span lang="en-US">According to </span>
          </span>
        </sup>
      </p>

      <div style="font-size: large;border-top:1px solid #000;border-bottom:1px solid #000;width:88%;margin-left:auto;margin-right:auto;text-align:center">
        <p style="margin-top:0;margin-bottom:5px">
          <strong>
            GLOBALG.A.P. GENERAL REGULATIONS IFA. VERSION 5.2. 1 February 2019
          </strong>
        </p>
        <p style="margin-top:5px;margin-bottom:5px">
          <strong>OPTION 1 -Con QMS</strong>
        </p>
        <p style="margin-top:5px;margin-bottom:5px;font-style:italic">
          <strong>
            ARAPORC ENTIDAD DE INSPECCION, S.L (*) declares that the production of the products mentioned on this certificate has been found to be compliant in accordance with the standard:
          </strong>
        </p>
        <p style="margin-top:5px;margin-bottom:5px">
          <span lang="en-US">GLOBALG.A.P. Control Points and Compliance Criteria </span>
        </p>
        <p style="margin-top:5px;margin-bottom:0">
          <span lang="en-US">All Farm Based, Livestock Base, Ruminat Base, Cattle and Sheep, Calf and Young Beef version 5.2. 1 February 2019</span>
        </p>
      </div>

      <div style="margin-left:10%;margin-right:auto;width:80%;margin-top:40px">
        <table cellspacing="0" cellpadding="3">
          <tbody>
            <tr style="width:100%">
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>PRODUCT</strong>
                    </span>
                  </span>
                </p>
              </td>
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>GLOBALG.A.P.<br />PRODUCT CERTIFICATE<br />NUMBER</strong>
                    </span>
                  </span>
                </p>
              </td>
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>NUMBER<br />OF SITES</strong>
                    </span>
                  </span>
                </p>
              </td>
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>COUNTRIES OF<br />DESTINATION</strong>
                    </span>
                  </span>
                </p>
              </td>
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>PARALLEL<br />PRODUCTION<br /></strong>
                    </span>
                  </span>
                </p>
              </td>
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>PARALLEL<br />OWNERSHIP</strong>
                    </span>
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US"></span>
                  </span>
                </p>
              </td>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US"></span>
                  </span>
                </p>
              </td>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US"></span>
                  </span>
                </p>
              </td>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US"></span>
                  </span>
                </p>
              </td>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US"></span>
                  </span>
                </p>
              </td>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US"></span>
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </template>

    <div style="width:90%;margin-left:12%;margin-right:auto;font-weight:bold;font-size:12px;margin-top:40px">
      <div style="float:left;width:15%">
        <p><br /></p>
        <p><br /></p>
        <p>
          <img src="data:image/jpeg;base64,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" />
        </p>
      </div>

      <div style="float:left;width:20%">
        <p>Date of issue</p>
        <p>(printing date of certificate)</p>
        <p>Valid from:</p>
        <p>Valid to:</p>
      </div>

      <div style="float:left;width:10%">
        <p>{{ formatDate(new Date()) }}</p>
        <p></p>
        <p>{{ formatDate(this.datos.fecha_expedicion) }}</p>
        <p>{{ formatDate(this.datos.fecha_hasta) }}</p>
      </div>

      <div style="float:left;width:25%">
        <p>Authorized by TERESA LOPEZ RIVAS</p>
        <p>Technical Director</p>
        <p><br /></p>
        <p>Date of certification decision:</p>
      </div>

      <div style="float:left;width:15%">
        <p><br /></p>
        <p><br /></p>
        <p><br /></p>
        <p>{{ formatDate(this.datos.fecha_certificado) }}</p>
      </div>
    </div>

    <div style="clear: both;"></div>

    <template v-if="isGanaderia">
      <div style="margin-left:10%">
        <p>
          <strong>
            ANNEX FOR GGN {{ this.datos.cliente.codigo }} <br />
            REGISTRATION Nº: {{ this.datos.codigo }}<br />
            DATE OF ISSUE: {{ formatDate(new Date()) }}<br />
            PRODUCTIONS SITE: {{ this.datos.auditoria.sites.length }}. OPTION 1 -Con QMS
          </strong>
        </p>
      </div>

      <div style="margin-left:10%;margin-right:auto;width:80%;margin-top:40px;margin-bottom:40px">
        <table cellspacing="0" cellpadding="3">
          <tbody>
            <tr style="width:100%">
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>Nº ORDEN</strong>
                    </span>
                  </span>
                </p>
              </td>
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>PRODUCER NAME AND ADDRESS<br />NOMBRE Y DIRECCION DEL PRODUCTOR</strong>
                    </span>
                  </span>
                </p>
              </td>
              <td style="background:#d9d9d9;width:16%">
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">
                      <strong>PRODUCT(S)<br />PRODUCTO(S)</strong>
                    </span>
                  </span>
                </p>
              </td>
            </tr>
            <tr v-for="(site, index) in this.datos.auditoria.sites" :key="index" >
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">{{ index+1 }}</span>
                  </span>
                </p>
              </td>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">{{ getNombreYDireccionProductor(site) }}</span>
                  </span>
                </p>
              </td>
              <td>
                <p align="center">
                  <span style="font-size: small;">
                    <span lang="en-US">{{ getProducto(site) }}</span>
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <div name="footer" style="font-size:small;padding-top:25px;/*background-color:#13ecef;*/font-weight:bold;color:#111;padding-bottom:30px">
      <p style="text-align:center;margin-bottom:0">
        <span>
          <span lang="en-US">
            <span v-if="isGanaderia">The annex contains details of the producers and productions sites included in the scope of this certificate<br /></span>
            This certificate is a property of Araporcei SL and overrides any other that may have been previously issued with the same number<br />
            Please contact Araporcei to check the validity of this document. <u>araporcei@araporcei.es</u><br />
            The current status of this certificate is always displayed at: <u>http://www.globalgap.org/search</u>
          </span>
        </span>
      </p>
      <hr style="border: .5px solid #000;width:65%;margin-left:auto;margin-right:auto;" />
      <p style="text-align:center;margin-top:0">
        <span>
          <span lang="en-US">
            ARAPORC ENTIDAD DE INSPECCION, S.L. * C.I.F.: B-91421685<br />
            Gabriel Mir&oacute; 3, Edificio Wertice 2<sup>da</sup> Planta Izquierda, Oficina 1 - 41703 Dos Hermanas (Sevilla) * Tel. 954.64.74.23 Fax 954.64.44.16 * www.araporcei.es
          </span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datos: { type: Object, default: () => {} }
  },
  computed:{
    clienteNombreCompleto() {
      let nombre = ''
      const cliente = this.datos.cliente
      if (cliente) {
        if (cliente.nombre) nombre += cliente.nombre
        if (cliente.primer_apellido) nombre += ' ' + cliente.primer_apellido
        if (cliente.segundo_apellido) nombre += ' ' + cliente.segundo_apellido
      }
      return nombre
    }
  },
  methods: {
    formatDate (date) {
      return date ? this.$moment(date).format('DD/MM/YYYY') : ''
    },
    isGanaderia() {
      let isGanaderia = false;

      this.datos.auditoria.sites.forEach(site => {
        if (site.nombre == 'Ganaderia')
          isGanaderia = true;
      });

      return isGanaderia;
    },
    isPienso() {
      let isPienso = false;

      this.datos.auditoria.sites.forEach(site => {
        if (site.nombre == 'Pienso')
          isPienso = true;
      });

      return isPienso;
    },
    getNombreYDireccionProductor(site) {
      let nombreProductor = '';
      let direccionProductor = '';

      site.site_data.forEach(data => {
        if (data.keyname == 'nombre_productor')
          nombreProductor = data.value;

        if (data.keyname == 'direccion_localidad_provincia_telefono_fax')
          direccionProductor = data.value;
      });

      return nombreProductor + ' - ' + direccionProductor;
    },
    getProducto(site) {
      let producto = '';

      site.site_data.forEach(data => {
        if (data.keyname == 'modulo_tipo_producto')
          producto = data.value;
      });

      return producto;
    }
  },
  mounted() {
    console.log(this.datos)
  }
}
</script>

